export default "__VITE_ASSET__f262555a__"